import React from 'react';

const PrintBulletinHeader = ({ etablissement, anneeAcademique, semestre }) => {
  const formatDate = (dateString) => {
    if (!dateString) return new Date().toLocaleDateString('fr-FR');
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <div className="header-section" style={{ marginBottom: '8px' }}>
      {/* En-tête administratif */}
      <div style={{ marginBottom: '6px' }}>
        {/* En-tête supérieur */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
          {/* Logo à gauche */}
          {(etablissement?.logo || etablissement?.logo_url) && (
            <div style={{ width: '15%', flexShrink: 0 }}>
              <img 
                src={etablissement.logo || etablissement.logo_url} 
                alt="Logo de l'établissement" 
                style={{ maxHeight: '50px', objectFit: 'contain' }}
              />
            </div>
          )}
          
          {/* Textes au centre */}
          <div style={{ width: '70%', textAlign: 'center' }}>
            <p style={{ 
              fontSize: '10px', 
              fontWeight: 'bold', 
              textTransform: 'uppercase', 
              marginBottom: '1px',
              letterSpacing: '0.5px'
            }}>
              RÉPUBLIQUE {etablissement?.pays ? `DU ${etablissement.pays.toUpperCase()}` : ''}
            </p>
            <div style={{ 
              width: '60px', 
              height: '1px', 
              backgroundColor: '#000', 
              margin: '1px auto 2px auto' 
            }}></div>
            {etablissement?.ministere && (
              <p style={{ 
                fontSize: '8px', 
                textTransform: 'uppercase', 
                marginBottom: '2px',
                fontWeight: '600'
              }}>
                MINISTÈRE DE {etablissement.ministere.toUpperCase()}
              </p>
            )}
            <h1 style={{ 
              fontSize: '12px', 
              fontWeight: 'bold', 
              marginBottom: '2px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              {etablissement?.libelle || etablissement?.nom || 'Établissement'}
            </h1>
            <p style={{ 
              fontSize: '8px', 
              fontStyle: 'italic', 
              marginBottom: '3px',
              fontWeight: '500'
            }}>
              « {etablissement?.devise || 'Excellence et Savoir'} »
            </p>
            <div style={{ 
              fontSize: '7px', 
              lineHeight: '1.2',
              marginBottom: '2px'
            }}>
              <span>Email: {etablissement?.email || 'N/A'}</span>
              <span style={{ margin: '0 3px' }}>|</span>
              <span>Contact: {etablissement?.contact || etablissement?.telephone || 'N/A'}</span>
              <span style={{ margin: '0 3px' }}>|</span>
              <span>BP: {etablissement?.bp || 'N/A'}</span>
              {(etablissement?.site_web || etablissement?.website) && (
                <>
                  <span style={{ margin: '0 3px' }}>|</span>
                  <span>Site: {etablissement.site_web || etablissement.website}</span>
                </>
              )}
            </div>
            <p style={{ fontSize: '7px', margin: '0' }}>
              {etablissement?.adresse || 'Adresse non spécifiée'}
            </p>
          </div>
          
          {/* Année académique à droite */}
          <div style={{ width: '15%', flexShrink: 0, textAlign: 'right' }}>
            <div style={{ 
              display: 'inline-block', 
              border: '1px solid #000', 
              borderRadius: '2px', 
              padding: '3px 4px', 
              textAlign: 'center',
              backgroundColor: '#f8f8f8'
            }}>
              <p style={{ fontSize: '7px', marginBottom: '1px', fontWeight: '600' }}>
                Année Académique
              </p>
              <p style={{ fontSize: '9px', fontWeight: 'bold', margin: '0' }}>
                {anneeAcademique?.libelle || 'N/A'}
              </p>
            </div>
          </div>
        </div>
        
        {/* Titre du document */}
        <div style={{ textAlign: 'center', marginTop: '6px' }}>
          <div style={{ 
            display: 'inline-block', 
            border: '2px solid #000', 
            padding: '4px 12px', 
            backgroundColor: '#f0f0f0'
          }}>
            <h2 style={{ 
              fontSize: '11px', 
              fontWeight: 'bold', 
              margin: '0 0 2px 0', 
              letterSpacing: '1px',
              textTransform: 'uppercase'
            }}>
              RELEVÉ DE NOTES
            </h2>
            <p style={{ 
              fontSize: '8px', 
              margin: '0', 
              fontWeight: '500'
            }}>
              Bulletin semestriel de l'étudiant - {semestre ? `Semestre ${semestre.numero}` : 'Semestre'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintBulletinHeader;
